import React from 'react';

const FLYOUT_TRANSITION_MS = 200;

/**
 * Collapsed sidebar flyout: fade + slide in/out before unmount.
 */
export function CollapsedNavSubmenu({ isOpen, children }) {
  const [mounted, setMounted] = React.useState(isOpen);
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    if (isOpen) {
      setMounted(true);
      return undefined;
    }
    setVisible(false);
    const timer = window.setTimeout(() => setMounted(false), FLYOUT_TRANSITION_MS);
    return () => window.clearTimeout(timer);
  }, [isOpen]);

  React.useEffect(() => {
    if (!mounted || !isOpen) return undefined;
    const frame = window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => setVisible(true));
    });
    return () => window.cancelAnimationFrame(frame);
  }, [mounted, isOpen]);

  if (!mounted) return null;

  return (
    <div
      className={`nav-sub nav-sub--collapsed-flyout${visible ? ' is-open' : ''}`}
      aria-hidden={!isOpen}
    >
      {children}
    </div>
  );
}

/**
 * Inline submenu when expanded; animated flyout when collapsed.
 */
export function NavSubmenu({ isOpen, isCollapsed, children }) {
  if (!isCollapsed) {
    return isOpen ? <div className="nav-sub">{children}</div> : null;
  }
  return <CollapsedNavSubmenu isOpen={isOpen}>{children}</CollapsedNavSubmenu>;
}
